import React from "react";

export const Section = ({ id, children, className = "", testId }) => (
  <section
    id={id}
    data-testid={testId}
    className={`max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-28 ${className}`}
  >
    {children}
  </section>
);

export const Eyebrow = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-[#C5A059]"
  >
    {children}
  </div>
);

export const Heading = ({ children, className = "", testId }) => (
  <h2
    data-testid={testId}
    className={`font-display text-3xl sm:text-4xl md:text-5xl text-[#EAE0D5] leading-[1.05] mt-3 ${className}`}
  >
    {children}
  </h2>
);

export const Lede = ({ children, className = "", testId }) => (
  <p
    data-testid={testId}
    className={`text-base md:text-lg text-[#A39E99] leading-relaxed mt-5 max-w-2xl ${className}`}
  >
    {children}
  </p>
);
